import { getCatalogMechanicalTests } from "@/pages/laboratory/repositories/CatalogMechanicalTestRepository";
import { getCatalogResultSources } from "@/pages/laboratory/repositories/CatalogResultSourceRepository";
import { getMechanicalSamples } from "@/pages/laboratory/repositories/MechanicalSampleRepository";
import { useCallback } from "react";
import { useMechanicalByHeatContext } from "../MechanicalByHeatContext";

export const useMechanicalData = () => {
	const { state, actions } = useMechanicalByHeatContext();

	// Remove 'actions' from dependencies - it's functionally stable despite reference changes
	const getCatalogData = useCallback(async () => {
		actions.setIsLoadingPage(true);
		const [testsResp, sourcesResp] = await Promise.all([
			getCatalogMechanicalTests(),
			getCatalogResultSources(),
		]);

		if (testsResp.ok) {
			actions.setMechanicalTests(testsResp.data.tables[0].rows);
		}
		if (sourcesResp.ok) {
			actions.setSources(sourcesResp.data.tables[0].rows);
		}
		actions.setIsLoadingPage(false);
	}, []);

	// Remove 'actions' from dependencies - it's functionally stable despite reference changes
	const getSampleData = useCallback(async () => {
		if (!state.heat?.HeatId) {
			actions.setMechanicalSamples([]);
			actions.setGrades([]);
			return;
		}
		actions.setIsLoadingGrid(true);
		const resp = await getMechanicalSamples(
			state.heat.HeatId,
			state.showOnlyValid ? "V" : null,
		);
		if (resp?.ok) {
			actions.setMechanicalSamples(resp.data.tables[0].rows);
			if (resp.data.tables[1]) {
				actions.setGrades(resp.data.tables[1].rows);
			}
		}
		actions.setIsLoadingGrid(false);
	}, [state.heat?.HeatId, state.showOnlyValid]);

	return {
		getCatalogData,
		getSampleData,
		isLoading:
			state.isLoadingPage || state.isLoadingGrid || state.isLoadingBackground,
	};
};
